import { useState } from 'react';
import { useNavigate } from 'react-router';
import { email as emailSchema } from 'zod';
import { mutateConfig } from '../api/mutationConfig';

export const Login = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const { mutate: login, isPending } = mutateConfig()<{ message: string }>({
    url: '/v1/ops/otp',
  });

  const isValid = emailSchema().safeParse(email).success;

  const handleSubmit = (e: { preventDefault(): void }) => {
    e.preventDefault();
    login(
      { email },
      { onSuccess: () => navigate('/confirm', { state: { email } }) }
    );
  }

  return (
    <div className="flex-1 flex items-center justify-center">
      <div className="w-full max-w-sm p-8 bg-white rounded-2xl shadow-sm">
        <h1 className="text-2xl font-semibold text-gray-900 mb-6">Sign in</h1>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label htmlFor="email" className="text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="jane@paywithpeppermint.com"
              required
              className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
            />
          </div>
          <button
            type="submit"
            disabled={!isValid || isPending}
            className="w-full py-2 px-4 bg-gray-900 text-white text-sm font-medium rounded-lg hover:bg-gray-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}
